import '@ionic/core/css/ionic.bundle.css';
import { arrowBack,
  arrowBackOutline,
  arrowForward,
  arrowForwardOutline,
  chevronBackOutline,
  personOutline,
  mailOutline,
  eyeOutline,
  eyeOffOutline,
  heartHalfOutline,
  personCircleOutline,
  heartCircleOutline,
  heartOutline,
  flameOutline,
  createOutline,
  closeOutline,
  trashOutline,
  pencilOutline,
  chevronForward,
  chevronForwardOutline,
  sadOutline,
  shieldCheckmarkOutline,
  logOutOutline,
  menuOutline,
  helpOutline,
 } from 'ionicons/icons';
import { addIcons } from 'ionicons';

// Registra los iconos personalizados
addIcons({
  'arrow-back': arrowBack,
  'arrow-back-outline': arrowBackOutline,
  'arrow-forward': arrowForward,
  'arrow-forward-outline': arrowForwardOutline,
  'chevron-back-outline': chevronBackOutline,
  'person-outline': personOutline,
  'mail-outline': mailOutline,
  'eye-outline': eyeOutline,
  'eye-off-outline': eyeOffOutline,
  'heart-half-outline': heartHalfOutline,
  'person-circle-outline': personCircleOutline,
  'heart-circle-outline': heartCircleOutline,
  'heart-outline': heartOutline,
  'flame-outline': flameOutline,
  'create-outline': createOutline,
  'close-outline': closeOutline,
  'trash-outline': trashOutline,
  'pencil-outline': pencilOutline,
  'chevron-forward': chevronForward,
  'chevron-forward-outline': chevronForwardOutline,
  'sad-outline': sadOutline,
  'shield-checkmark-outline': shieldCheckmarkOutline,
  'log-out-outline': logOutOutline,
  'menu-outline': menuOutline,
  'help-outline': helpOutline,
});